const chooesdata = [{
    inputdata: '',
    title: '客户编号',
    fontSize: '14px',
    color: '#333333',
    placeholder: '请输入',
    types: 'text',
    inputtype: 'input',
    width: '130px',
    disabled: false,
    // lablewith: '90px',
},
{
    inputdata: '',
    title: '客户名称',
    fontSize: '14px',
    color: '#333333',
    placeholder: '请输入',
    types: 'text',
    inputtype: 'input',
    width: '130px',
    // lablewith: '90px',

},
{
    inputdata: '',
    title: '客户类型',
    fontSize: '14px',
    color: '#333333',
    placeholder: '全部',
    types: '',
    inputtype: 'select',
    width: '130px',
    btx: true,
    // lablewith: '90px',
    options: [{
        key: "1",
        value: "哈哈哈",
    },
    {
        key: "2",
        value: "嘿嘿",
    }]
},
{
    inputdata: '',
    title: '质量状态',
    fontSize: '14px',
    color: '#333333',
    placeholder: '全部',
    types: '',
    inputtype: 'select',
    width: '130px',
    btx: true,
    // lablewith: '90px',
    options: [{
        key: "1",
        value: "哈哈哈",
    },
    {
        key: "2",
        value: "嘿嘿",
    }]
},
]
export default chooesdata;
